import React, { useState } from "react";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import { useNavigate } from "react-router-dom";
import agGridHelper from "../../../shared/ag-grid-helper";
import ButtonIcon from "../../../shared/controls/ButtonIcon";
import FiltroOrdenesTrabajo from "./filtroOrdenesTrabajo";
import UseApiOrdenServicio from "../../../api/taller/useApiOrdenServicio";
import Calendario from "./calendario/calendario";
import { getSessionState } from "../../../hooks/useSessionState";

const OrdenesTrabajo = ({ soloLectura }) => {
    const filtroKey = "filtrosOrdenTrabajo";
    const [datos, setDatos] = useState([]);
    const [filtros, setFiltros] = useState(null);
    const [esVistaDeLista, setEsVistaDeLista] = useState(true);
    const [gridApi, setGridApi] = useState(null);
    const history = useNavigate();
    const apiOrdenServicio = UseApiOrdenServicio();
    const prepararFiltrosApi = (valores = {}) => {
        const empresaSeleccionada = valores.empresaId;

        const empresaId =
            empresaSeleccionada?.id ??
            empresaSeleccionada?.value ??
            empresaSeleccionada ??
            0;

        return {
            ...valores,

            tipoUnidadId:
                valores.tipoUnidadId?.map((item) => item?.id ?? item) ?? [],

            tipoServicioId:
                valores.tipoServicioId?.map((item) => item?.id ?? item) ?? [],

            estatus:
                valores.estatus?.map((item) => item?.id ?? item) ?? [],

            empresaId: Number(empresaId) || 0,
        };
    };

    async function buscar(filtrosSeleccionados, paramsApi) {
        agGridHelper.showLoad(gridApi, paramsApi, true);
        setFiltros(filtrosSeleccionados);

        try {
            const filtrosApi = prepararFiltrosApi(filtrosSeleccionados);

            const resultado = await apiOrdenServicio.filtrar(filtrosApi);

            setDatos(resultado);
        } finally {
            agGridHelper.hideLoad(gridApi, paramsApi, false);
        }
    }

    const onGridReady = async (params) => {
        setGridApi(params.api);
    };

    async function nuevo() {
        history("/taller/mantenimiento/nuevo_orden/0");
    }

   async function exportar() {
    const filtrosGuardados = getSessionState(filtroKey) ?? {};

    const empresaSeleccionada = filtrosGuardados.empresaId;

    const empresaId =
        empresaSeleccionada?.id ??
        empresaSeleccionada?.value ??
        empresaSeleccionada ??
        0;

    const filtrosApi = {
        ...filtrosGuardados,

        tipoUnidadId:
            filtrosGuardados.tipoUnidadId?.map(
                (item) => item?.id ?? item,
            ) ?? [],

        tipoServicioId:
            filtrosGuardados.tipoServicioId?.map(
                (item) => item?.id ?? item,
            ) ?? [],

        estatus:
            filtrosGuardados.estatus?.map(
                (item) => item?.id ?? item,
            ) ?? [],

        empresaId: Number(empresaId) || 0,
    };

    await apiOrdenServicio.excel(filtrosApi);
}

    const ButtonsHeader = () => {
        return (
            <div className="ag-grid header-icons">
                <ButtonIcon
                    title="Descargar"
                    onClick={exportar}
                    iconName="BiDownload"
                />

                {!soloLectura && (
                    <ButtonIcon
                        title="Agregar"
                        className="grid-action center"
                        iconName="MdAddBox"
                        onClick={nuevo}
                    />
                )}
            </div>
        );
    };

    return (
        <>
            <FiltroOrdenesTrabajo
                filtroKey={filtroKey}
                handleSubmit={buscar}
                cambiarVista={setEsVistaDeLista}
                esVistaDeLista={esVistaDeLista}
                gridaApi={gridApi}
            />

            {esVistaDeLista && (
                <div className="ag-theme-balham grid-principal">
                    <AgGridReact
                        rowSelection="single"
                        enableSorting
                        enableFilter
                        pagination
                        frameworkComponents={{
                            goToDetail: agGridHelper.GoToDetailFormatter,
                            buttonsHeader: ButtonsHeader,
                            dateFormatter: agGridHelper.DateFormatter,
                        }}
                        onGridReady={onGridReady}
                        rowData={datos}
                        overlayLoadingTemplate={agGridHelper.loadingOverlay}
                        defaultColDef={agGridHelper.defaultColumns}
                        getRowClass={(params) =>
                            params.data?.nombreColor ?? ""
                        }
                    >
                        <AgGridColumn
                            field="codigo"
                            headerName="ORDEN TRABAJO"
                            cellClass="center"
                            flex={2}
                        />

                        <AgGridColumn
                            field="empresa"
                            headerName="EMPRESA"
                            cellClass="center"
                            flex={2}
                        />

                        <AgGridColumn
                            field="costo"
                            headerName="COSTO"
                            headerClass="center"
                            minWidth={100}
                            flex={2}
                        />

                        <AgGridColumn
                            field="tipoServicio"
                            headerName="TIPO SERVICIO"
                            minWidth={210}
                            headerClass="center"
                            flex={3}
                        />

                        <AgGridColumn
                            field="descripcion"
                            headerName="DESCRIPCION"
                            flex={6}
                        />

                        <AgGridColumn
                            field="fechaProgramada"
                            headerName="FECHA PROGRAMADA"
                            cellRenderer="dateFormatter"
                            minWidth={100}
                            flex={3}
                        />

                        <AgGridColumn
                            field="tipoUnidad"
                            headerName="TIPO UNIDAD"
                            minWidth={100}
                            cellClass="center"
                            flex={3}
                        />

                        <AgGridColumn
                            field="numeroEconomico"
                            headerName="NO. ECONOMICO"
                            minWidth={120}
                            flex={2}
                            headerClass="center"
                        />

                        <AgGridColumn
                            field="esExterno"
                            headerName="ES EXTERNO"
                            minWidth={120}
                        />

                        <AgGridColumn
                            field="estatus"
                            headerName="ESTATUS"
                            cellClass="center"
                        />

                        <AgGridColumn
                            maxWidth={120}
                            headerName="VER"
                            cellRenderer="goToDetail"
                            pinned="right"
                            path="/taller/mantenimiento/editar_orden"
                            headerComponent="buttonsHeader"
                        />
                    </AgGridReact>
                </div>
            )}

            {!esVistaDeLista && (
                <Calendario filtros={filtros} />
            )}
        </>
    );
};

export default OrdenesTrabajo;